<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <rect x="2.66602" y="2.66602" width="10.6667" height="10.6667" rx="2" stroke="#2ED0A2" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.66602 6.66732H13.3327" stroke="#2ED0A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.66732 2.66602V13.3327" stroke="#2ED0A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>